import { z } from "zod/v4"
import type { DocumentSnapshotLike } from "../firestore"
import { UserId } from "../id"
import { CreatedAt, UpdatedAt } from "./system"

export const WelcomeDeliveryDeliveredUserDocumentMeta = z.object({
  user_id: z.string().describe("配信対象のユーザーID"),
})

export type WelcomeDeliveryDeliveredUserDocumentMeta = z.infer<typeof WelcomeDeliveryDeliveredUserDocumentMeta>

export const WelcomeDeliveryDeliveredUserDocumentBody = z.intersection(
  WelcomeDeliveryDeliveredUserDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export type WelcomeDeliveryDeliveredUserDocumentBody = z.infer<typeof WelcomeDeliveryDeliveredUserDocumentBody>

export type WelcomeDeliveryDeliveredUserDocument = WelcomeDeliveryDeliveredUserDocumentBody & {
  id: UserId,
}

export class WelcomeDeliveryDeliveredUserDocuments {

  static toDocumentData(doc: WelcomeDeliveryDeliveredUserDocument): object {
    return {
      ...doc,
      // id は document path に入るので入れない
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): WelcomeDeliveryDeliveredUserDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: UserId(doc.id),
      user_id: data["user_id"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}
